export const translations_sex_umfrage = {
  'thanks for participating': {
    de: 'Vielen Dank für Ihre Teilnahme!',
    fr: 'Merci de votre participation!',
  },
  'do again': {
    de: 'Eine erneutes Ausfüllen des Fragebogens ist leider nicht möglich.',
    fr: "Nous sommes désolés, mais il n'est pas possible de remplir le questionnaire à nouveau.",
  },
  'choose group to compare': {
    de: 'Mit welcher Personengruppe sollen wir Sie vergleichen?',
    fr: 'Avec quel groupe de personnes souhaitez-vous vous comparer?',
  },
  sex: {
    de: 'Geschlecht',
    fr: 'Sexe',
  },
  age: {
    de: 'Alter',
    fr: 'Âge',
  },
  orientation: {
    de: 'Sexuelle Orientierung',
    fr: 'Orientation sexuelle',
  },
  status: {
    de: 'Beziehungsstatus',
    fr: 'Statut de relation',
  },
  'all genders': {
    de: 'Alle Geschlechter',
    fr: 'Tous les genres',
  },
  male: {
    de: 'Männlich',
    fr: 'Masculin',
  },
  female: {
    de: 'Weiblich',
    fr: 'Féminin',
  },
  diverse: {
    de: 'Divers',
    fr: 'Divers',
  },
  'all ages': {
    de: 'Alle Altersgruppen',
    fr: 'Tous les âges',
  },
  'all orientations': {
    de: 'Alle sexuellen Orientierungen',
    fr: 'Toutes les orientations sexuelles',
  },
  hetero: {
    de: 'Heterosexuell',
    fr: 'Hétérosexuelle',
  },
  homo: {
    de: 'Homosexuell',
    fr: 'Homosexual',
  },
  other: {
    de: 'Andere',
    fr: 'Autre',
  },
  'all relation duration': {
    de: 'Alle Beziehungen',
    fr: 'Toutes les relations',
  },
  single: { de: 'Single', fr: 'Célibataire' },
  'less than a year': {
    de: 'Beziehung < 1 Jahr',
    fr: 'Relation < 1 an',
  },
  'one to five years': {
    de: 'Beziehung 1 – 5 Jahre',
    fr: 'Relation 1 - 5 ans',
  },
  'more than five years': {
    de: 'Beziehung > 5 Jahre',
    fr: 'Relation > 5 ans',
  },
  satisfaction: {
    de: 'Zufriedenheit',
    fr: 'Satisfaction',
  },
  'first some personal questions': {
    de: 'Zuerst folgen einige Fragen zu Ihrer Person, um die Ergebnisse besser einordnen und vergleichen zu können.',
    fr: 'Tout d’abord, voici quelques questions sur votre personne, afin de pouvoir mieux classer et comparer les résultats.',
  },
  orgasm: {
    de: 'Orgasmus',
    fr: 'Orgasme',
  },
  never: {
    de: 'Nie',
    fr: 'Jamais',
  },
  always: {
    de: 'Immer',
    fr: 'Toujours',
  },
  'self image': {
    de: 'Selbstbild und Bedürfnisse',
    fr: 'Image de soi et besoins',
  },
  'does not apply at all': {
    de: 'Trifft überhaupt nicht zu',
    fr: "Pas du tout d'accord",
  },
  'does fully apply': {
    de: 'Trifft voll und ganz zu',
    fr: "Tout à fait d'accord",
  },
  'do not agree at all': {
    de: 'Stimme gar nicht zu',
    fr: "Pas du tout d'accord",
  },
  'fully agree': {
    de: 'Stimme voll und ganz zu',
    fr: "Tout à fait d'accord",
  },
  'disagreed to consent': {
    de: 'Um an der Umfrage teilzunehmen, müssen Sie damit einverstanden sein, dass die von Ihnen gemachten Angaben anonym für wissenschaftliche Zwecke ausgewertet werden.',
    fr: "Pour participer à l'enquête, vous devez accepter que les informations que vous fournissez soient évaluées de manière anonyme à des fins scientifiques.",
  },
  'back to consent': {
    de: 'Zurück zur Einverständniserklärung',
    fr: 'Retour à la déclaration de consentement',
  },
  'now questions to sexuality': {
    de: 'Nun folgen Fragen zu Ihrer Sexualität und Ihren sexuellen Bedürfnissen.',
    fr: 'Voici maintenant quelques questions sur votre sexualité et vos besoins sexuels.',
  },
  'answered allready': {
    de: 'von 21 Fragen beantwortet.',
    fr: 'réponses sur 21 questions',
  },
  'answer all': {
    de: 'Beantworten Sie alle 21 Fragen, um zur Auswertung zu gelangen.',
    fr: "Répondez aux 21 questions pour accéder à l'évaluation.",
  },
  send: {
    de: 'Absenden',
    fr: 'Envoyer',
  },
  '18 to 29': {
    de: 'zwischen 18 und 29 Jahren',
    fr: 'entre 18 et 29 ans',
  },
  '30 to 49': {
    de: 'zwischen 30 und 49 Jahren',
    fr: 'entre 30 et 49 ans',
  },
  'over 50': {
    de: 'über 50 Jahren',
    fr: 'plus de 50 ans',
  },
  satisfied: {
    de: 'Zufrieden',
    fr: 'Satisfait',
  },
  unsatisfied: {
    de: 'Unzufrieden',
    fr: 'Insatisfait',
  },
  user: {
    de: 'Sie',
    fr: 'Vous',
  },
}
